import { Badge, Card, Chip, Divider, Grid, Pagination, Paper } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import CrowdCards from "nextus/Cards/CrowdCards";
import PropTypes from "prop-types";
import MiniBarChart from "./MiniBarChart";
import { ArrowUpward, TrendingDown, TrendingFlat, TrendingUp } from "@mui/icons-material";
import moment from "moment";
import SoftBadge from "components/SoftBadge";
import CameraImageProcessed from "../components/CameraImageProcessed";
import { useState } from "react";


function GeneralTab({ crowd_data, data, user_role, setHoveredDevices, navigateToDevice, epoch, mode }) {

    const [page, setPage] = useState(0);

    let page_length = 2;
    // console.log(crowd_data)

    // debugger;

    const handleChange = (event, value) => {
        setPage(value);
    };


    return (
        <SoftBox>

            <Grid container spacing={1}>
                {crowd_data.map(function (camera, index) {

                    // debugger;
                    // var chart_data = [];

                    var threshold = 0.04;

                    var trending_text = ` (${(camera.change > 0 ? '+' : '') + Math.round(camera.change * 100)}%)`

                    let trend;

                    if (camera.change > threshold) {
                        trend = (<><TrendingUp></TrendingUp>{trending_text}</>);
                    }
                    else if (camera.change > threshold * -1) {
                        trend = (<><TrendingFlat></TrendingFlat>{trending_text}</>);
                    }
                    else {
                        trend = (<><TrendingDown></TrendingDown>{trending_text}</>);
                    }

                    let density;
                    let density_colour = '';
                    let text_color;

                    if (camera.density < 10) {
                        density = 'Low'
                        density_colour = 'rgb(38, 124, 204)'
                        text_color = '#FFFFFF'
                    }
                    else if (camera.density < 20) {
                        density = 'Medium'
                        density_colour = 'rgb(131, 180, 226)'
                        text_color = '#FFFFFF'
                    }
                    else if (camera.density < 30) {
                        density = 'High'
                        density_colour = 'rgb(239,128,98)'
                        text_color = '#FFFFFF'
                    }
                    else {
                        density = 'Very High'
                        density_colour = 'rgb(255, 24, 24)'
                        text_color = '#fff'
                    }

                    let content;
                    // debugger

                    switch (mode) {
                        case 0:
                            content = (<Grid container spacing={1}>
                                <Grid item xs={12} lg={4} align="center">
                                    <SoftBox sx={{ borderRight: '1px solid lightgrey' }}>
                                        <SoftTypography variant="body2">Trend</SoftTypography>
                                        <SoftTypography variant="h5" display="inline">
                                            {trend}
                                        </SoftTypography>
                                    </SoftBox>
                                </Grid>
                                <Grid item xs={12} lg={4} align="center">
                                    <SoftBox sx={{ borderRight: '1px solid lightgrey' }}>
                                        <SoftTypography variant="body2">Density</SoftTypography>
                                        <Chip sx={{ backgroundColor: density_colour, color: text_color, fontSize: "18px", height: "24px" }} label={density}></Chip>
                                    </SoftBox>
                                </Grid>
                                <Grid item xs={12} lg={4} align="right">

                                    <SoftBox sx={{ height: '50px' }}>
                                        <MiniBarChart data={camera.preview_graph}></MiniBarChart>
                                    </SoftBox>

                                </Grid>
                            </Grid>)
                            break;

                        case 1:
                            content = (<>
                                <SoftTypography variant="body2" display="inline"> {camera.description && camera.description.data && camera.description.data.description ? camera.description.data.description : 'N/A'}</SoftTypography>
                            </>)
                            break;
                        case 2:
                            content = (<>
                                <CameraImageProcessed image_data={{ _id: camera.image_id }}></CameraImageProcessed>
                            </>)


                    }


                    return (<Grid item xs={12} key={index} onMouseEnter={() => setHoveredDevices([camera.uuid])} onMouseLeave={() => setHoveredDevices([])}>
                        <Card sx={{ cursor: 'pointer' }} onClick={() => navigateToDevice(camera.uuid)} >
                            <SoftBox m={2}>
                                <Grid container spacing={1}>
                                    <Grid item xs={12} lg={6} >
                                        <SoftTypography variant="h5">{camera.name}</SoftTypography>
                                    </Grid>
                                    <Grid item xs={12} lg={6} align="right">
                                        <SoftTypography variant="body2" display="inline">Count: </SoftTypography>
                                        <SoftTypography variant="h5" display="inline">{camera.count}</SoftTypography>
                                    </Grid>
                                </Grid>

                                <Divider sx={{ my: 1 }}></Divider>
                                <SoftBox>{content}</SoftBox>

                            </SoftBox>
                        </Card>
                    </Grid>)
                })}
            </Grid>
        </SoftBox >

    )
}
GeneralTab.propTypes = {
    crowd_data: PropTypes.object,
    user_role: String,
    setHoveredDevice: PropTypes.func
}


export default GeneralTab;
